import React from 'react';
import { getURLVal } from '../../domains/URLDomain';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel'
import pixelIds from '../../api/fbPixelConfig'

class SiteCheckoutSuccess extends React.Component {
  componentDidMount = () => {
    const coachOrgId = getURLVal('coachOrgId');
    if (!coachOrgId) return;

    const price = getURLVal('priceLabel') || null

    this.props.actions.paymentActions.fetchProductInfo(coachOrgId);

    if(pixelIds[coachOrgId]){
      const pixelId = pixelIds[coachOrgId];
      ReactPixel.init(pixelId);
      ReactPixel.pageView();
      if(price){
        const adjustedPrice = price/100
        ReactPixel.trackSingle(pixelId, 'Purchase', {
          value: adjustedPrice,
          currency: 'USD'
        })
      }
    }

    ReactGA.event({
      category: 'Purchase',
      action: 'Completed Payment',
      label: getURLVal('gaPlanLabel') || null
    });
  }

  renderMessage = () => {
    if (this.props.siteCheckout.get('checkoutSuccessMessage')){
      return (
        <div className='instr-text'>
          {this.props.siteCheckout.get('checkoutSuccessMessage')}
        </div>
      )
    } else if(this.props.siteCheckout.get('checkoutSuccessDeepLink')){
      return (
        <div className='instr-text'>
          To access the content, please: <br />
          1. Download the app <a href={this.props.siteCheckout.get('checkoutSuccessDeepLink')}>here</a>.<br />
          2. Log in using the same email and password.
        </div>
      )
    } else if(this.props.siteCheckout.get('deepLink')){
      return (
        <div className='instr-text'>
          To access the content, please: <br />
          1. Download the app <a href={this.props.siteCheckout.get('deepLink')}>here</a>.<br />
          2. Log in using the same email and password.
        </div>
      )
    } else {
      return (
        <div className='loader-container'>
          <div className='loader' />
        </div>
      )
    }
  }

  render() {
    return (
      <div className='confirmation-container flex-column align-center flex-center'>
        <img
          src={require('../../images/confirmationCheckmark.png')}
          className='confirmation-checkmark'
        />
        <div className='confirmation-text'>
          Thank you for becoming a member.
        </div>
        {this.renderMessage()}
      </div>
    );
  }
}

SiteCheckoutSuccess.displayName = 'SiteCheckoutSuccess';

export default SiteCheckoutSuccess;


// WEBPACK FOOTER //
// ./src/components/payments/SiteCheckoutSuccess.js